import { VacationOptionLabel } from './VacationMarker';

interface PersonOptionLabelProps {
    option: unknown;
    label: string | null;
    /** The work email of an option that shares its name with another one in the list, from `useSameNameEmail`. */
    sameNameEmail: string | null;
}

/**
 * A dropdown option's label, followed on the same line by the work email when another option shares the
 * name. The name keeps up to 70% of the row, so the email always keeps room to be read and hovered.
 */
const PersonOptionLabel = ({ option, label, sameNameEmail }: PersonOptionLabelProps): JSX.Element => {
    if (!sameNameEmail) {
        return <VacationOptionLabel option={option} label={label} />;
    }
    return (
        <span className="flex w-full min-w-0 items-baseline gap-4">
            <span className="max-w-[70%] shrink-0 truncate">
                <VacationOptionLabel option={option} label={label} />
            </span>
            <span className="text-grey-600 min-w-0 flex-1 truncate text-right text-xs" title={sameNameEmail}>
                {sameNameEmail}
            </span>
        </span>
    );
};

export default PersonOptionLabel;
